import type { Components } from '@/api/generated/api';
import { SchoolClassType } from '@/api/generated/api.enum';
import { useSchoolClassType } from '@/schoolClasses/useSchoolClassType';
import { computed, type ComputedRef, type MaybeRefOrGetter } from 'vue';

/** the container the UI acts on: a saved class/group, or a draft still being created */
export type TViewedSchoolClass = {
  type?: Components.Schemas.SchoolClassType;
};

interface IGroupComposable {
  /** whether the viewed container is a group */
  isGroup: ComputedRef<boolean>;
}

/**
 * Groups as seen from the container the user is looking at — resolved from the passed class, the
 * nearest `provideViewedSchoolClass`, then the routed class.
 */
export const useGroup = (schoolClass?: MaybeRefOrGetter<TViewedSchoolClass | null | undefined>): IGroupComposable => {
  const schoolClassType = useSchoolClassType(schoolClass);

  return { isGroup: computed<boolean>(() => schoolClassType.value === SchoolClassType.group) };
};
